'use strict';

/**
 * @ngdoc overview
 * @name observatoireApp.titresMiniers
 * @description
 * # Module titres-miniers
 *
 * Module pour la gestion des titres miniers
 */

require('./titres-miniers.css');
require('./titres-miniers.routes');
require('./titres-miniers.controller');
require('./titres-miniers-details.controller');
require('./titres-miniers.service');
